module.exports = __webpack_public_path__ + "static/media/nohugggs.0a4e8082.png";